module.exports = __webpack_public_path__ + "img/celebrate-people.15dd1428.svg";